/**
 * @file Contains all keys used for the user settings.
 */

export const onboardingCompleteUserSettingsKey = import.meta.env
    .VITE_USER_SETTINGS_ONBOARDING_COMPLETE_KEY

export const timeProgressToDateKey = import.meta.env
    .VITE_USER_SETTINGS_TIME_PROGRESS_TO_DATE_KEY

export const useCalendarForTrackingsOverviewKey = import.meta.env
    .VITE_USER_SETTINGS_USE_CALENDAR_FOR_TRACKINGS_OVERVIEW_KEY
